// Copyright 2024-present BAIKAL AI Inc.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file bareun/dict_search_service.proto (package bareun, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bareun/dict_search_service.proto.
 */
export const file_bareun_dict_search_service: GenFile = /*@__PURE__*/
  fileDesc("CiBiYXJldW4vZGljdF9zZWFyY2hfc2VydmljZS5wcm90bxIGYmFyZXVuIrkBChFTZWFyY2hEaWN0UmVxdWVzdBIPCgdwYXR0ZXJuGAEgASgJEigKBmFuY2hvchgCIAEoDjIYLmJhcmV1bi5EaWN0U2VhcmNoQW5jaG9yEgsKA3BvcxgDIAMoCRIQCghzdGRfb25seRgEIAEoCBINCgVsaW1pdBgFIAEoBRIOCgZvZmZzZXQYBiABKAUSFwoPd2l0aF9kZWZpbml0aW9uGAcgASgIEhIKCmNvdW50X29ubHkYCCABKAgicAoPRGljdFNlYXJjaFNlbnNlEhAKCHNlbnNlX25vGAEgASgNEhIKCmRlZmluaXRpb24YAiABKAkSEAoIY2F0ZWdvcnkYAyABKAkSEwoLdGFyZ2V0X2NvZGUYBCABKAUSEAoIZXhhbXBsZXMYBSADKAkigAIKD0RpY3RTZWFyY2hFbnRyeRIMCgR3b3JkGAEgASgJEg4KBm9yaWdpbhgCIAEoCRILCgNuZmQYAyABKAkSCwoDcG9zGAQgASgJEhMKC3NlbnNlX2NvdW50GAUgASgFEicKBnNlbnNlcxgGIAMoCzIXLmJhcmV1bi5EaWN0U2VhcmNoU2Vuc2USDQoFY29uanUYByABKAkSFQoNcHJvbnVuY2lhdGlvbhgIIAEoCRISCgppc19ub25fc3RkGAkgASgIEhIKCmlzX2RpYWxlY3QYCiABKAgSFwoPaXNfbm9ydGhfa29yZWFuGAsgASgIEhAKCHN0ZF93b3JkGAwgASgJIrIBChJTZWFyY2hEaWN0UmVzcG9uc2USKAoHZW50cmllcxgBIAMoCzIXLmJhcmV1bi5EaWN0U2VhcmNoRW50cnkSFQoNdG90YWxfbWF0Y2hlZBgCIAEoBRIUCgx0b3RhbF9zZW5zZXMYAyABKAUSDQoFcmVnZXgYBCABKAkSEQoJdHJ1bmNhdGVkGAUgASgIEhIKCmVsYXBzZWRfbXMYBiABKAMSDwoHc2Nhbm5lZBgHIAEoBSqOAQoQRGljdFNlYXJjaEFuY2hvchIbChdESUNUX1NFQVJDSF9BTkNIT1JfV09SRBAAEh0KGURJQ1RfU0VBUkNIX0FOQ0hPUl9QUkVGSVgQARIdChlESUNUX1NFQVJDSF9BTkNIT1JfU1VGRklYEAISHwobRElDVF9TRUFSQ0hfQU5DSE9SX0NPTlRBSU5TEAMyWgoRRGljdFNlYXJjaFNlcnZpY2USRQoKU2VhcmNoRGljdBIZLmJhcmV1bi5TZWFyY2hEaWN0UmVxdWVzdBoaLmJhcmV1bi5TZWFyY2hEaWN0UmVzcG9uc2UiAEKHAQoKY29tLmJhcmV1bkIWRGljdFNlYXJjaFNlcnZpY2VQcm90b1ABWiliYXJldW4uYWkvbGFuZy9iYXJldW4vZ2VucHJvdG8vYmFyZXVuO3N2Y6ICA0JYWKoCBkJhcmV1bsoCBkJhcmV1buICEkJhcmV1blxHUEJNZXRhZGF0YeoCBkJhcmV1bmIGcHJvdG8z");

/**
 * 검색 요청.
 *
 * @generated from message bareun.SearchDictRequest
 */
export type SearchDictRequest = Message<"bareun.SearchDictRequest"> & {
  /**
   * 자소 슬롯 패턴(필수). 문법은 아래와 같다.
   *
   *   토큰                뜻
   *   ------------------  ----------------------------------------------------
   *   "다" 같은 음절       그 음절 그대로(NFD 로 분해해 매칭)
   *   {초/중/종}           한 음절의 자소 조건. 필드는 '/' 로 구분한다
   *   {초중종}             '/' 없이 원자 3개를 나란히 써도 된다 — {[ㄱㄴㄷ].[ㄴㄹㅁ]}
   *   *                   음절 0개 이상
   *   ?                   음절 정확히 1개
   *
   * 슬롯의 각 필드(초성/중성/종성)에 쓸 수 있는 표기:
   *
   *   표기        뜻
   *   ----------  --------------------------------------------------------
   *   비움 또는 . 아무거나
   *   ㅅ          그 자소
   *   ㄹㄱ        합성 자모의 두 자모 이어쓰기 — 겹받침(ㄹㄱ→ㄺ)·이중모음(ㅗㅏ→ㅘ)·
   *               된소리(ㄱㄱ→ㄲ). ㄺ 같은 합성 자모는 키보드로 직접 칠 수 없어
   *               이 표기를 정식으로 받는다(한 글자 ㄺ 도 그대로 된다)
   *   ㄱ|ㅋ       여럿 중 하나
   *   [ㄱㄴㄷ]     여럿 중 하나(정규식 문자 클래스 표기). [^ㄱㄴ] 로 부정도 된다
   *   -           (종성 전용) 받침 없음
   *   +           (종성 전용) 받침이 있기만 하면 됨
   *
   * 예:
   *   "{ㅅ//ㄴ}다"            → 신다
   *   "{/ㅚ/-}다"             → 괴다 꾀다 되다 외다 죄다 …
   *   "*{//ㅎ}다"             → 낳다 넣다 놓다 내놓다 …
   *   "{[ㄱㄴㄷ].[ㄴㄹㅁ]}"    → 초성 ㄱ·ㄴ·ㄷ, 종성 ㄴ·ㄹ·ㅁ 인 1음절 표제어
   *   "아지" + anchor=SUFFIX  → 송아지 망아지 …
   *
   * @generated from field: string pattern = 1;
   */
  pattern: string;

  /**
   * 패턴이 표제어의 어느 위치에 걸리는지. 기본은 표제어 전체(WORD).
   *
   * @generated from field: bareun.DictSearchAnchor anchor = 2;
   */
  anchor: DictSearchAnchor;

  /**
   * 품사 필터(비우면 전체). 우리말샘 품사 표기("동사"·"명사"·"보조 동사" …)를 그대로 쓰거나,
   * 아래 별칭을 쓸 수 있다: "용언"·"동사류"·"형용사류"·"체언"·"부사류"·"수식언"·"관계언".
   * 여러 개를 주면 그중 하나라도 맞으면 통과(OR)다.
   *
   * @generated from field: repeated string pos = 3;
   */
  pos: string[];

  /**
   * true 면 비표준어·방언·북한어 항목을 제외한다. 기본 false(전부 포함).
   *
   * @generated from field: bool std_only = 4;
   */
  stdOnly: boolean;

  /**
   * 돌려줄 표제어 최대 개수. 0 이면 기본값 100, 상한은 1000 이다.
   * (총 몇 건이 걸렸는지는 limit 과 무관하게 total_matched 로 알려준다.)
   *
   * @generated from field: int32 limit = 5;
   */
  limit: number;

  /**
   * 건너뛸 표제어 개수(페이지 넘기기용). 기본 0.
   *
   * @generated from field: int32 offset = 6;
   */
  offset: number;

  /**
   * true 면 표제어마다 뜻풀이·용례까지 실어 준다. 기본 false — 목록만 훑을 때
   * 응답이 수십 배 커지는 것을 막기 위해 기본은 표제어·품사·활용형만 담는다.
   *
   * @generated from field: bool with_definition = 7;
   */
  withDefinition: boolean;

  /**
   * true 면 항목을 담지 않고 개수만 센다(넓은 패턴의 규모를 먼저 확인할 때).
   *
   * @generated from field: bool count_only = 8;
   */
  countOnly: boolean;
};

/**
 * Describes the message bareun.SearchDictRequest.
 * Use `create(SearchDictRequestSchema)` to create a new message.
 */
export const SearchDictRequestSchema: GenMessage<SearchDictRequest> = /*@__PURE__*/
  messageDesc(file_bareun_dict_search_service, 0);

/**
 * 표제어 하나에 딸린 뜻풀이 하나.
 *
 * @generated from message bareun.DictSearchSense
 */
export type DictSearchSense = Message<"bareun.DictSearchSense"> & {
  /**
   * 우리말샘 어깨번호(senseinfo.sense_no). 0 = 미부여.
   *
   * @generated from field: uint32 sense_no = 1;
   */
  senseNo: number;

  /**
   * 뜻풀이.
   *
   * @generated from field: string definition = 2;
   */
  definition: string;

  /**
   * 전문 분야 등 분류.
   *
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * 우리말샘 항목 고유 번호(target_code).
   *
   * @generated from field: int32 target_code = 4;
   */
  targetCode: number;

  /**
   * 용례.
   *
   * @generated from field: repeated string examples = 5;
   */
  examples: string[];
};

/**
 * Describes the message bareun.DictSearchSense.
 * Use `create(DictSearchSenseSchema)` to create a new message.
 */
export const DictSearchSenseSchema: GenMessage<DictSearchSense> = /*@__PURE__*/
  messageDesc(file_bareun_dict_search_service, 1);

/**
 * 검색 결과 표제어 하나. 우리말샘은 뜻풀이마다 항목이 갈리므로, 같은 (표제어, 품사)
 * 는 하나로 묶고 뜻풀이를 senses 에 모아 준다.
 *
 * @generated from message bareun.DictSearchEntry
 */
export type DictSearchEntry = Message<"bareun.DictSearchEntry"> & {
  /**
   * 표제어(완성형, NFC). 예: "송아지".
   *
   * @generated from field: string word = 1;
   */
  word: string;

  /**
   * 우리말샘 원문 표제어. 접사·복합어 표시('-', '^')가 남아 있을 수 있다.
   *
   * @generated from field: string origin = 2;
   */
  origin: string;

  /**
   * 표제어의 자소 분해형(NFD). 어떤 자소 조건에 걸렸는지 눈으로 확인할 때 쓴다.
   *
   * @generated from field: string nfd = 3;
   */
  nfd: string;

  /**
   * 품사(우리말샘 표기). 예: "명사", "동사".
   *
   * @generated from field: string pos = 4;
   */
  pos: string;

  /**
   * 이 (표제어, 품사) 에 묶인 뜻풀이 개수.
   *
   * @generated from field: int32 sense_count = 5;
   */
  senseCount: number;

  /**
   * 뜻풀이 목록. with_definition=false 면 비어 있다.
   *
   * @generated from field: repeated bareun.DictSearchSense senses = 6;
   */
  senses: DictSearchSense[];

  /**
   * 활용형 정보.
   *
   * @generated from field: string conju = 7;
   */
  conju: string;

  /**
   * 발음.
   *
   * @generated from field: string pronunciation = 8;
   */
  pronunciation: string;

  /**
   * 비표준 표기 여부.
   *
   * @generated from field: bool is_non_std = 9;
   */
  isNonStd: boolean;

  /**
   * 방언 여부.
   *
   * @generated from field: bool is_dialect = 10;
   */
  isDialect: boolean;

  /**
   * 북한어 여부.
   *
   * @generated from field: bool is_north_korean = 11;
   */
  isNorthKorean: boolean;

  /**
   * 비표준어·방언일 때의 표준 대체어(있을 때만).
   *
   * @generated from field: string std_word = 12;
   */
  stdWord: string;
};

/**
 * Describes the message bareun.DictSearchEntry.
 * Use `create(DictSearchEntrySchema)` to create a new message.
 */
export const DictSearchEntrySchema: GenMessage<DictSearchEntry> = /*@__PURE__*/
  messageDesc(file_bareun_dict_search_service, 2);

/**
 * 검색 결과.
 *
 * @generated from message bareun.SearchDictResponse
 */
export type SearchDictResponse = Message<"bareun.SearchDictResponse"> & {
  /**
   * 걸린 표제어 목록(offset/limit 적용 후). count_only=true 면 비어 있다.
   *
   * @generated from field: repeated bareun.DictSearchEntry entries = 1;
   */
  entries: DictSearchEntry[];

  /**
   * 필터까지 모두 적용해 걸린 **표제어(품사별로 묶은 것)** 총 개수. limit 과 무관하다.
   *
   * @generated from field: int32 total_matched = 2;
   */
  totalMatched: number;

  /**
   * 걸린 사전 항목(뜻풀이 행) 총 개수. 표제어 하나가 여러 뜻풀이를 가지므로 total_matched 보다 크다.
   *
   * @generated from field: int32 total_senses = 3;
   */
  totalSenses: number;

  /**
   * 서버가 실제로 사용한 NFD 정규식. 자소는 눈으로 구별되지 않으므로, 패턴이 어떻게
   * 해석됐는지 확인·디버깅할 때 쓴다.
   *
   * @generated from field: string regex = 4;
   */
  regex: string;

  /**
   * total_matched 가 limit+offset 보다 커서 잘렸는지 여부.
   *
   * @generated from field: bool truncated = 5;
   */
  truncated: boolean;

  /**
   * 검색에 걸린 시간(밀리초). 색인 없이 전수 검색하므로 규모 감을 잡는 데 쓴다.
   *
   * @generated from field: int64 elapsed_ms = 6;
   */
  elapsedMs: bigint;

  /**
   * 훑은 사전 항목 수(사전 전체 크기).
   *
   * @generated from field: int32 scanned = 7;
   */
  scanned: number;
};

/**
 * Describes the message bareun.SearchDictResponse.
 * Use `create(SearchDictResponseSchema)` to create a new message.
 */
export const SearchDictResponseSchema: GenMessage<SearchDictResponse> = /*@__PURE__*/
  messageDesc(file_bareun_dict_search_service, 3);

/**
 * 패턴이 표제어의 어느 위치에 걸리는지.
 *
 * @generated from enum bareun.DictSearchAnchor
 */
export enum DictSearchAnchor {
  /**
   * 표제어 전체가 패턴과 맞아야 한다(기본).
   *
   * @generated from enum value: DICT_SEARCH_ANCHOR_WORD = 0;
   */
  WORD = 0,

  /**
   * 표제어의 앞부분이 맞으면 된다. 예: "송"으로 시작하는 말.
   *
   * @generated from enum value: DICT_SEARCH_ANCHOR_PREFIX = 1;
   */
  PREFIX = 1,

  /**
   * 표제어의 끝부분이 맞으면 된다. 예: "-아지"로 끝나는 말(송아지·망아지).
   *
   * @generated from enum value: DICT_SEARCH_ANCHOR_SUFFIX = 2;
   */
  SUFFIX = 2,

  /**
   * 표제어 어디든 들어 있으면 된다.
   *
   * @generated from enum value: DICT_SEARCH_ANCHOR_CONTAINS = 3;
   */
  CONTAINS = 3,
}

/**
 * Describes the enum bareun.DictSearchAnchor.
 */
export const DictSearchAnchorSchema: GenEnum<DictSearchAnchor> = /*@__PURE__*/
  enumDesc(file_bareun_dict_search_service, 0);

/**
 * DictSearchService 는 우리말샘 사전을 **자소(음소) 조건**으로 뒤지는 검색 서비스다 (#1899).
 *
 * 왜 따로 두나:
 *   완성형 한글("신")로는 "초성이 ㅅ 이고 종성이 ㄴ 인 음절" 같은 조건을 표현할 수 없다. 그래서
 *   표제어를 NFD(정준 분해)로 풀어 자모 단위 정규식을 걸어야 하는데, 사람이 키보드로 치는
 *   'ㅅ'(U+3145, 호환용 자모)과 NFD 안의 초성 'ᄉ'(U+1109)·종성 'ᆺ'(U+11BA)은 **서로 다른 문자**라
 *   손으로 정규식을 쓰면 오류가 아니라 조용히 0건이 나온다. 이 서비스는 사람이 읽고 쓸 수 있는
 *   슬롯 패턴을 받아 그 변환을 서버가 전담한다.
 *
 * 구현 규약:
 *   - 색인을 만들지 않는다. 요청마다 우리말샘 FlatBuffers(urimal-dict.fb) 전체를 훑는다. 서버는
 *     사전 DB(PostgreSQL)를 쓰지 않고, LIKE 검색으로는 자소 조건을 애초에 걸 수 없기 때문이다.
 *   - 우리말샘 사전은 맞춤법 교정(rev) 빌드에만 실린다. 따라서 이 서비스도 rev 빌드에서만 등록된다.
 *     기본(형태소 분석 전용) 빌드에 요청하면 unimplemented 로 떨어진다.
 *
 * @generated from service bareun.DictSearchService
 */
export const DictSearchService: GenService<{
  /**
   * SearchDict 는 자소 패턴으로 우리말샘 표제어를 찾는다.
   *
   * @generated from rpc bareun.DictSearchService.SearchDict
   */
  searchDict: {
    methodKind: "unary";
    input: typeof SearchDictRequestSchema;
    output: typeof SearchDictResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bareun_dict_search_service, 0);

